<!-- Rechter Rand, oberhalb des bugBIC-Feedback-Tabs.
     Die Bildschirmmitte ist bereits belegt: chatBIC bei 50% + 90px, bugBIC bei 50% - 90px
     (siehe [offset] am <bug-bic-badge> in app.component.html). Dieser Reiter sitzt darueber bei
     50% - 180px und ist nur sichtbar, solange etwas laeuft - er kann die beiden also nicht
     dauerhaft verdraengen. Wird der Abstand dort geaendert, muss dieser Wert mitziehen.

     Die feste Hoehe ist wichtig: der Container traegt -translate-y-1/2, verschiebt sich also um die
     HAELFTE SEINER EIGENEN HOEHE. Lag das Panel als Flex-Kind mit drin, wuchs der Container beim
     Aufklappen und der Reiter sprang nach oben. Das Panel ist deshalb absolut positioniert und
     damit aus dem Fluss - der Reiter bleibt liegen, wo er liegt. -->
@if (visible) {
  <div (mouseenter)="openPanel()"
       (mouseleave)="schedulePanelClose()"
       class="fixed right-0 top-[calc(50%_-_180px)] -translate-y-1/2 z-[9997] h-[38px]">

    <!-- Detail-Panel, links neben dem Reiter; ausserhalb des Flusses (s. Kommentar oben).

         Die 8px Abstand zum Reiter (mr-2) waren Niemandsland: die Maus verliess dort den Container,
         mouseleave feuerte, und das Panel war weg, bevor man es erreichte - anklicken liess es sich
         praktisch nie. Das ::after-Element ueberbrueckt genau diesen Spalt; es gehoert zur Karte,
         also bleibt der Zeiger fuer mouseleave im Container. Unsichtbar (kein Hintergrund), es
         faengt nur Zeiger-Ereignisse ab. Aendert sich mr-2, muss after:w-2 mitziehen. -->
    @if (panelOpen) {
      <div class="absolute right-full top-0 mr-2 w-[300px] rounded-lg bg-white p-4
                  shadow-[0_6px_24px_rgba(0,0,0,0.25)]
                  after:absolute after:left-full after:top-0 after:h-full after:w-2 after:content-['']">
        <div class="flex flex-row items-start justify-between gap-2">
          <span class="text-sm font-medium text-gray-900">{{ label }}</span>
          @if (!running && failed > 0) {
            <button (click)="dismiss()" aria-label="Meldung schließen"
                    class="shrink-0 text-gray-400 hover:text-gray-600" type="button">
              <fa-icon [icon]="faXmark" class="text-sm"></fa-icon>
            </button>
          }
        </div>

        <!-- Je laufender Vorgang ein Abschnitt: Upload und Loeschen koennen gleichzeitig laufen.
             Der Abschnitt ist als Ganzes anklickbar und fuehrt in die Dateiansicht SEINES Projekts
             (nicht des ausgewaehlten - s. openFiles). Deshalb je Vorgang ein Button statt eines
             Klicks auf das ganze Panel: die Kopfzeile traegt den Schliessen-Button, und ein
             Button im Button ist nicht erlaubt. -->
        @for (activity of activities; track activity.key) {
          <button (click)="openFiles(activity)"
                  [attr.aria-label]="'Zu den Dateien: ' + activity.title"
                  class="group/act mt-3 block w-full border-t border-gray-200 pt-3 text-left
                         first:mt-2 first:border-0 first:pt-0"
                  type="button">
            <div class="flex flex-row items-center justify-between gap-2">
              <span class="min-w-0 truncate text-xs font-medium text-gray-700 group-hover/act:text-blue">{{ activity.title }}</span>
              <!-- Bis die Dateiansicht steht, vergehen mehrere Sekunden - ohne Spinner sieht der
                   Klick aus, als waere er ins Leere gegangen (und wird wiederholt). -->
              @if (navigatingProjectId === activity.progress.projectId) {
                <fa-icon [icon]="faSpinner" class="shrink-0 animate-spin text-[10px] text-blue"></fa-icon>
              } @else {
                <fa-icon [icon]="faArrowRight"
                         class="shrink-0 text-[10px] text-gray-300 transition-colors group-hover/act:text-blue"></fa-icon>
              }
            </div>

            <!-- Nur wenn mehrere Projekte gleichzeitig etwas offen haben: dann stehen hier zwei
                 Abschnitte mit derselben Ueberschrift, und man muss sehen, welcher wohin fuehrt. -->
            @if (activity.projectName) {
              <div class="mt-0.5 truncate text-[11px] text-gray-400">{{ activity.projectName }}</div>
            }
            @if (navigatingProjectId === activity.progress.projectId) {
              <div class="mt-0.5 text-[11px] text-blue">Dateien werden geöffnet …</div>
            }

            @if (activity.progress.active > 0) {
              <!-- Fortschritt: Nenner ist die Gesamtmenge, Zaehler alles Abgeschlossene inkl. Fehler -->
              <div class="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-gray-100">
                <div [style.width.%]="percent(activity.progress)"
                     class="h-full rounded-full bg-green transition-all duration-300"></div>
              </div>
              <div class="mt-1 text-xs text-gray-500">
                <!-- total 0 bei laufendem Vorgang: der SharePoint-Abgleich liest noch die Quelle, die Menge steht
                     noch nicht fest. "0 von 0" sah aus, als gaebe es nichts zu tun. -->
                @if (activity.progress.total > 0) {
                  {{ settled(activity.progress) }} von {{ activity.progress.total }}
                } @else {
                  Wird vorbereitet …
                }
              </div>

              @for (name of activity.progress.currentNames; track name) {
                <div class="mt-1 flex flex-row items-center gap-2 text-xs text-gray-600">
                  <fa-icon [icon]="faSpinner" class="shrink-0 animate-spin text-[10px] text-gray-400"></fa-icon>
                  <span class="min-w-0 truncate">{{ name }}</span>
                </div>
              }
            }

            @for (name of activity.progress.failedNames; track name) {
              <div class="mt-1 flex flex-row items-center gap-2 text-xs text-gray-600">
                <fa-icon [icon]="faCircleExclamation" class="shrink-0 text-[10px] text-red-500"></fa-icon>
                <span class="min-w-0 truncate">{{ name }}</span>
              </div>
            }

            <!-- Je Vorgang, weil es sich unterscheidet: die Klassifizierung laeuft rein
                 serverseitig und ueberlebt ein Neuladen, Upload und Loeschen nicht. Ein
                 gemeinsamer Hinweis behauptete fuer die Klassifizierung etwas Falsches. -->
            @if (activity.progress.active > 0) {
              <div class="mt-2 text-xs text-gray-400">
                @if (activity.survivesReload) {
                  Läuft auf dem Server weiter – ein Neuladen der Seite ist unproblematisch.
                } @else {
                  Läuft im Hintergrund weiter. Ein Neuladen der Seite bricht noch wartende Dateien ab.
                }
              </div>
            }
          </button>
        }
      </div>
    }

    <!-- Reiter: eingeklappt nur das Icon (gleiche Breite wie chatBIC/Feedback), der Zaehler fährt
         beim Hover aus - dieselbe max-w-Mechanik wie im chatBIC-Reiter. -->
    <button (click)="openFiles()"
            [attr.aria-label]="label + ' – zu den Dateien'"
            [class]="running ? 'bg-blue text-white' : 'bg-red-500 text-white'"
            class="group flex h-[38px] cursor-pointer items-center overflow-hidden rounded-l-lg px-3
                   shadow-[0_4px_16px_rgba(0,0,0,0.2)] transition-all duration-200 ease-in-out
                   hover:shadow-[0_6px_24px_rgba(0,0,0,0.3)]"
            type="button">
      <!-- Fester 20px-Slot, damit der eingeklappte Reiter genauso breit ist wie chatBIC und die
           Feedback-Badge. Beide polstern mit px-3, aber ihr Icon ist 20px breit: das chatBIC-Icon
           hat viewBox 640x512 (= 1.25em) und die Feedback-Badge reserviert w-[20px] explizit.
           faSpinner/faCircleExclamation sind mit 512x512 nur 1em = 16px breit - ohne diesen Slot
           war der Reiter 4px schmaler als die beiden. -->
      <span class="flex w-[20px] shrink-0 items-center justify-center">
        <fa-icon [class.animate-spin]="running"
                 [icon]="running ? faSpinner : faCircleExclamation"
                 class="text-base"></fa-icon>
      </span>
      <span class="max-w-0 overflow-hidden whitespace-nowrap text-sm font-medium tabular-nums opacity-0
                   transition-all duration-200 ease-in-out
                   group-hover:ml-2 group-hover:max-w-[120px] group-hover:opacity-100">{{ tabLabel }}</span>
    </button>
  </div>
}
